import axios from "axios";
import {
  FETCH_PRODUCTOS_REQUEST,
  FETCH_PRODUCTOS_SUCCESS,
  FETCH_PRODUCTOS_FAILURE,
} from "./types";
import { PATH } from "../../utils";

const api = axios.create({
  baseURL: PATH,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const actionProductosGet = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_PRODUCTOS_REQUEST });
  try {
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
    const res = await api.get("/productos", { headers: authHeader(), params: cleanParams });
    const items = Array.isArray(res.data) ? res.data : res.data?.items ?? [];
    dispatch({ type: FETCH_PRODUCTOS_SUCCESS, payload: items });
  } catch (err) {
    const msg = err?.response?.data?.detail || err.message || "Error al cargar productos";
    dispatch({ type: FETCH_PRODUCTOS_FAILURE, payload: { error: msg } });
  }
};

export const apiProductosInstance = api;
export { authHeader as authHeaderProductos };
